import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import AnimatedPage from "./AnimatedPage";

const MyTeacherStats = ({ isAuthenticated }) => {
  const [counters, setCounters] = useState({});
  const [oldCounters, setOldCounters] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        "https://api.my-teacher.in/background/stats"
      );
      setCounters(data);
    };
    const fetchOldData = async () => {
      const { data } = await axios.get("https://api.my-teacher.in/counters");
      setOldCounters(data);
    };
    fetchData();
    fetchOldData();
  }, []);

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <AnimatedPage>
      <div className="flex w-full h-5/6 justify-center items-center">
        <table className="border m-5">
          <thead>
            <tr>
              <th className="text-center border">Item</th>
              <th className="text-center border">Today</th>
              <th className="text-center border">Yesterday</th>
              <th className="text-center border">Total so far</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="text-center border">Visits</th>
              <td className="text-center border">
                {oldCounters.visitorsToday}
              </td>
              <td className="text-center border">
                {oldCounters.visitorsYesterday}
              </td>
              <td className="text-center border">
                {oldCounters.totalVisitors}
              </td>
            </tr>
            <tr>
              <th className="text-center border">Questions</th>
              <td className="text-center border">
                {oldCounters.questionsToday}
              </td>
              <td className="text-center border">
                {oldCounters.questionsYesterday}
              </td>
              <td className="text-center border">
                {oldCounters.totalQuestions}
              </td>
            </tr>
            <tr>
              <th className="text-center border">Mock Tests</th>
              <td className="text-center border">{oldCounters.testsToday}</td>
              <td className="text-center border">
                {oldCounters.testsYesterday}
              </td>
              <td className="text-center border">{oldCounters.totalTests}</td>
            </tr>
            <tr>
              <th className="text-center border">Shares</th>
              <td className="text-center border">{oldCounters.sharesToday}</td>
              <td className="text-center border">
                {oldCounters.sharesYesterday}
              </td>
              <td className="text-center border">{oldCounters.totalShares}</td>
            </tr>
            <tr>
              <th className="text-center border">Online Tests</th>
              <td className="text-center border">
                {counters.online_tests_today}
              </td>
              <td className="text-center border">
                {counters.online_tests_yesterday}
              </td>
              <td className="text-center border">
                {counters.online_tests_total}
              </td>
            </tr>
            <tr>
              <th className="text-center border">Offline Tests</th>
              <td className="text-center border">
                {counters.offline_tests_today}
              </td>
              <td className="text-center border">
                {counters.offline_tests_yesterday}
              </td>
              <td className="text-center border">
                {counters.offline_tests_total}
              </td>
            </tr>
            <tr>
              <th className="text-center border">Examinees</th>
              <td className="text-center border">
                {counters.tests_taken_by_no_of_examinees_today}
              </td>
              <td className="text-center border">
                {counters.tests_taken_by_no_of_examiness_yesterday}
              </td>
              <td className="text-center border">
                {counters.tests_taken_by_no_of_examinees_total}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </AnimatedPage>
  );
};

export default MyTeacherStats;
